export const UserRolesRoutes = [
  {
    path: 'invitation/:invitation_hash',
    lazy: () => import('./invitation.page'),
  },
] as const
